export default __webpack_public_path__ + "static/media/thumbnail.0275683c.png";